/**
 * The chain this build sends on, from VITE_CHAIN_ID (unset = Base Sepolia).
 * Kept free of wagmi/viem so the wallet API service can declare it without
 * pulling crypto code into bundles that never use the wallet.
 *
 * The server's chain is NOT configured: it is derived from APP_ENV
 * (server/app/Support/WalletNetwork.php: production = Base mainnet 8453,
 * anything else = Base Sepolia 84532). Every pending tip, withdrawal and
 * confirm carries this value, and the server refuses any other chain
 * (`chain_mismatch`) before a pending row exists, so a build on the wrong
 * network can never move money the server would verify elsewhere.
 */
export const BASE_MAINNET_CHAIN_ID = 8453;
export const BASE_SEPOLIA_CHAIN_ID = 84532;

export const IS_TESTNET_BUILD =
  import.meta.env.VITE_CHAIN_ID === '84532' || import.meta.env.VITE_CHAIN_ID === undefined;

export const BUILD_CHAIN_ID = IS_TESTNET_BUILD ? BASE_SEPOLIA_CHAIN_ID : BASE_MAINNET_CHAIN_ID;
